import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveTrigger, IClientDetailsStore, IClientDetailsActions } from '../types';

const onArchiveTrigger: IThunkArchiveTrigger = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.archiveClientTrigger(payload);

    const triggers = localState.triggers.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: true },
    );

    setClientDetails({ triggers });
  },
);

export default onArchiveTrigger;
